module.exports = __webpack_public_path__ + "img/T6-A-xh_00.04460056.png";